import { getAnalyticsActor, posthog } from './posthog'

/**
 * Kết quả một lần gia hạn phiên mà tab này chờ xong:
 *   - `refreshed`: tab này tự gọi `/auth/refresh` thành công.
 *   - `reused_other_tab`: tab khác vừa gia hạn trong lúc tab này chờ lock, nên
 *     tab này dùng luôn cookie mới, không gọi refresh.
 *   - `unauthorized`: phiên chết thật (401/403) — người dùng bị đưa về màn
 *     đăng nhập. Đây là con số cần về gần 0 sau fix đá phiên khi mở nhiều tab.
 *   - `timeout` / `network`: mạng hoặc server chậm, chưa chắc đã bị đăng xuất.
 */
export type AuthRefreshOutcome =
    | 'refreshed'
    | 'reused_other_tab'
    | 'unauthorized'
    | 'timeout'
    | 'network'

/**
 * Một event cho mỗi lần gia hạn phiên đã kết thúc (các lời gọi trùng trong cùng
 * tab gộp thành một). KHÔNG gửi token, cookie, response body hay raw error.
 * Analytics lỗi hoặc tắt không được chặn việc gia hạn phiên.
 */
export function captureAuthRefresh(input: {
    outcome: AuthRefreshOutcome
    /** Server trả 409 (tab khác vừa rotate) và tab này đã gọi lại một lần. */
    raceRetried: boolean
    /** Trình duyệt có Web Locks, nên các tab gia hạn lần lượt. */
    crossTabLock: boolean
}) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        posthog.capture('auth_session_refresh', {
            schema_version: 1,
            event_id: crypto.randomUUID(),
            ...actor,
            outcome: input.outcome,
            race_retried: input.raceRetried,
            cross_tab_lock: input.crossTabLock,
        })
    } catch {
        // Analytics không được chặn việc gia hạn phiên.
    }
}
